import type { AxiosResponse } from 'axios';
import type { JSONAPICreateReturnLabelBatchEntry } from '~/types/APIReturnLabels';

import { WEB_ORDERS_API } from '~/services/web-orders.service';
import { microServiceAPI } from '~/services/api';

export type CreateReturnLabelBatchEntryParams = {
  orderId: string;
  batchEntryId?: number;
};

export type CreateReturnLabelBatchEntryResponse = Promise<
  AxiosResponse<JSONAPICreateReturnLabelBatchEntry>
>;

/**
 * Service function to create a batch entry for a return label
 * @param {CreateReturnLabelBatchEntryParams} { orderID, batchEntryId? }
 * @returns
 */
export function createReturnLabelBatchEntry({
  orderId,
  batchEntryId,
}: CreateReturnLabelBatchEntryParams): CreateReturnLabelBatchEntryResponse {
  return microServiceAPI.request({
    url: `${WEB_ORDERS_API}/${orderId}/return`,
    method: 'POST',
    ...(batchEntryId && {
      data: {
        shipment: batchEntryId,
      },
    }),
  });
}
